/**
 *    @author: Andrew Sheen
 *    @since:  2020-10-30
 * 
 */

export const Limit = {
       Parents:  4,    // how many parents can be added             @see InputData
       Children: 5     // how many child(Subject) can be added      @see InputData
}

export const City = {
      NorthYork     :"_NorthYork_497",
      Scarborough   :"_Scarborough_497",
      EastYork      :"_EastYork_497",
      Etobicoke     :"_Etobicoke_497",
      York          :"_York_497",
      Waterloo      :"_Waterloo_234",

      Walkerton:"_Walkerton_57",
      Clinton:"_Clinton_80",
      Fergus:"_Fergus_83",
      Haliburton:"_Haliburton_125",
      Georgetown:"_Georgetown_184",
      Lindsay:"_Lindsay_219",
      Almonte:"_Almonte_301",
      Alliston:"_Alliston_321",
      Simcoe:"_Simcoe_331",
      Winchester:"_Winchester_335",
      PortPerry:"_PortPerry_424"      
}

export const CityName = {
      NorthYork    :"NORTH YORK (TORONTO)",
      Scarborough  :"SCARBOROUGH (TORONTO)",
      EastYork     :"EAST YORK (TORONTO)",
      Etobicoke    :"ETOBICOKE (TORONTO)",
      York         :"YORK (TORONTO)",
      Waterloo     :"WATERLOO (KITCHENER)",
                   
      Walkerton   :"WALKERTON (BROCKTON)",
      Clinton     :"CLINTON (CENTRAL HURON)",
      Fergus      :"FERGUS (CENTRE WELLINGTON)",
      Haliburton  :"HALIBURTON (DYSART ET AL)",
      Georgetown  :"GEORGETOWN (HALTON HILLS)",
      Lindsay     :"LINDSAY (KAWARTHA LAKES)",
      Almonte     :"ALMONTE (MISSISSIPPI MILLS)",
      Alliston    :"ALLISTON (NEW TECUMSETH)",
      Simcoe      :"SIMCOE (NORFOLK COUNTY)",
      Winchester  :"WINCHESTER (NORTH DUNDAS)",
      PortPerry   :"PORT PERRY (SCUGOG)"      
}

export const Progress = {
       BirthReg: 1,
       Start: 1,
            Eligibility: 2,
            AboutChild: 3,
            AboutParent: 4,
            Review: 5,
       OrderBC: 6,
       CCB: 7,
       SIN: 8,
       ESR: 9,
       Receipt: 10,

       Summary: 11,
       Additional: 12,

       Init:0,
       Working:1,
       Done:2,
       OptOut:4       
}


export const Path = {
       Start:"start",
       BeforeYouBegin:"before_you_begin",

       Setup:"setup",
       Setup1:"setup_1",
       Setup2:"setup_2",
       Setup3:"setup_3",
       Setup4:"setup_4",
       Setup5:"setup_5",

       AboutTheChild:"about_the_child",
       AboutTheChildMain:"about_the_child_main",
       AboutTheChildScreen2:"about_the_child_screen_2",

       AboutTheParents:"about_the_parents",
       AboutTheParentsMain:"about_the_parents_main",
       AboutTheParentsScreen:"about_the_parents_screen_",
       AboutTheParentsScreen1:"about_the_parents_screen_1",
       AboutTheParentsScreen2:"about_the_parents_screen_2",
       AboutTheParentsScreen3:"about_the_parents_screen_3",
       AboutTheParentsScreen4:"about_the_parents_screen_4",

       ContactInfoAndMailingAddress:"contact_info_and_mailing_address",
       ConfirmAddressRange:"confirm_address_range",

       FinalReview:"final_review",
       Transition1:"transition_1",

       BirthCertificate:"birth_certificate",
       BirthCertificateAreYouSure:"birth_certificate_are_you_sure",
       Transition2:"transition_2",
       
       CCBMain:"CCB_main",
       CCBAreYouSure:"CCB_are_you_sure",
       SINMain:"SIN_main",
       SINAreYouSure:"SIN_are_you_sure",
       ESRMain:"ESR_main",
       ESRAreYouSure:"ESR_are_you_sure",
       OrderSummary:"order_summary",
       NextRegistration:"next_registration",
       ProvincialPayment:"provincial_payment",
       Finished:"finished",
       AdditionalInfo:"additional_info",
       FAQ:"FAQ",
       ORGContactInformation:"ORG_contact_information",
       error:"error",
       Home:""
}

export const GATitle = {
      Start:"start",
      BeforeYouBegin:"before_you_begin",

      Setup:"setup",
      Setup1:"setup_1",
      Setup2:"setup_2",
      Setup3:"setup_3",
      Setup4:"setup_4",
      Setup5:"setup_5",

      AboutTheChild:"about_the_child",
      AboutTheChildMain:"about_the_child_main",
      AboutTheChildScreen2:"about_the_child_screen_2",

      AboutTheParents:"about_the_parents",
      AboutTheParentsMain:"about_the_parents_main",
      AboutTheParentsScreen1:"about_the_parents_screen_1",
      AboutTheParentsScreen2:"about_the_parents_screen_2",
      AboutTheParentsScreen3:"about_the_parents_screen_3",
      AboutTheParentsScreen4:"about_the_parents_screen_4",

      ContactInfoAndMailingAddress:"contact_info_and_mailing_address",
      ConfirmAddressRange:"confirm_address_range",

      FinalReview:"final_review",
      Transition1:"transition_1",

      BirthCertificate:"birth_certificate",
      BirthCertificateAreYouSure:"birth_certificate_are_you_sure",
      Transition2:"transition_2",
      
      CCBMain:"CCB_main",
      CCBAreYouSure:"CCB_are_you_sure",
      SINMain:"SIN_main",
      SINAreYouSure:"SIN_are_you_sure",
      ESRMain:"ESR_main",
      ESRAreYouSure:"ESR_are_you_sure",
      OrderSummary:"order_summary",
      NextRegistration:"next_registration",
      ProvincialPayment:"provincial_payment",
      Finished:"finished",
      AdditionalInfo:"additional_info",
      FAQ:"FAQ",
      ORGContactInformation:"ORG_contact_information",
      Home:""
}

/**
export const Button = { 
            Next:       "button.next" , 
            Next_alt:   "button.next_alt", 
            Previous:   "button.prev", 
            Cancel:     "button.cancel", 
            Cancel_alt: "button.cancel_alt", 
            START:      "button.get_started" ,
            START_alt:  "button.get_started_alt", 
            Agree:      "button.agree" ,
            Agree_alt:  "button.agree_alt"
}
 */

export const GAData = {

     "Button":"Button clicks"
    ,"Link":"Link clicks" 
    ,"Image":"Image clicks"

    ,"email_receipt": { group:"email a receipt copy button",label:"email a receipt copy"}
    ,"download_receipt": { group:"download a receipt PDF copy button",label:"download a receipt PDF"}
    ,"FAQ_registration": { group:"FAQ Registration link",label:"FAQ Registration"}

    ,"FAQ_Certificate": { group:"FAQ Certificate link",label:"FAQ Certificate"}
    ,"FAQ_CCB": { group:"FAQ CCB link",label:"FAQ CCB"}
    ,"FAQ_SIN": { group:"FAQ SIN link",label:"FAQ SIN"}
    ,"FAQ_ESR": { group:"FAQ ESR link",label:"FAQ ESR"}
    ,"Progress_Bar": { group:"Progress Bar link",label:"Progress Bar"}

    ,"BC_parental":       { group:"Birth Certificate with Parental Image",label:"Birth Certificate with Parental"}
    ,"Birth_Certificate": { group:"Birth Certificate Image",label:"Birth Certificate"}
    ,"onca_Newborn":      { group:"Ontario.ca/Newborn link",label:"Ontario.ca/Newborn"}
    ,"email_ORG":         { group:"Send Email to ORG Button",label:"Send Email to ORG"}
    ,"cancel_app":        { group:"Cancel this application Button",label:"Cancel this application"}
    ,"switch_pounds":     { group:"Switch to pounds and ounces Link",label:"Switch to pounds and ounces"}
    ,"continue_product":  { group:"Continue Button",label:"Continue"}
    ,"no_BC":             { group:"I don't want to order a birth certificate button",label:"I don't want to order a birth certificate"}
    ,"whatIf_no_BC":      { group:"What if I don't want to order a birth certificate Link",label:"What if I don't want to order a birth certificate"}
    ,"whatIf_no_additional": { group:"What if I don't want to apply for additional services Link",label:"What if I don't want to apply for additional services"}
    ,"back_areYouSure":   { group:"Back Link",label:"Back"}
    ,"returnTo_BC":       { group:"Return to order a birth certificate Button",label:"Return to order a birth certificate"}
    ,"statement_LB":      { group:"Statement of Live Birth Image",label:"Statement of Live Birth"}
    ,"no_RESP":           { group:"I don't want to request information about RESPs Link",label:"I don't want to request information about RESPs"}
    ,"returnTo_onca":     { group:"Return to Ontario.ca Button",label:"Return to Ontario.ca"}
    ,"OHIP":              { group:"OHIP for babies Link",label:"OHIP for babies"}
    ,"Vaccines":          { group:"Vaccines and Immunization Link",label:"Vaccines and Immunization"}
    ,"Childhood":         { group:"Early Childhood Link",label:"Early Childhood"}
    ,"find_childcare":    { group:"Find and pay for childcare Link",label:"Find and pay for childcare"}
    ,"Indian":            { group:"Indian status card Link",label:"Indian status card"}
    ,"child_deceased":    { group:"Is this child deceased Field",label:"Is this child deceased Field"}
}

